export default {"src":"/_next/static/media/camera-white.0d0ac4e0.svg","height":21,"width":21};